import {
  autofillScreenshotsSchema,
  autofillSourcesSchema,
  autofillSuggestedFormDataSchema,
} from "@redotech/redo-dispute-db-schema/disputely-autofill-fields";
import * as z from "zod";

// Passthrough of the Disputely §8.1 autofill result. suggestedFormData is a loose
// key→value map; the Profile tab maps its keys onto the typed reclaimProfile fields.
export const getDisputelyAutofill = {
  name: "getDisputelyAutofill" as const,
  input: z.object({ url: z.string() }),
  output: z.object({
    status: z.enum(["generated", "soft_failed", "failed"]),
    error: z.string().nullish(),
    suggestedFormData: autofillSuggestedFormDataSchema.nullish(),
    screenshots: autofillScreenshotsSchema.nullish(),
    sources: autofillSourcesSchema.nullish(),
    notFound: z.array(z.string()).nullish(),
  }),
};
